import { createRoot } from "react-dom/client";
import AppRoot from "./components/AppRoot";
import { BrowserRouter } from 'react-router-dom';
const root = createRoot(document.getElementById("app"));
root.render(
  <BrowserRouter>
    <AppRoot />
  </BrowserRouter>
);